import api from "api/api";

export const getHistorySubcontractorByFiltersQuery = async ({
  scope,
  idKey,
  idValue,
}) =>
  await api.get(
    `/datatrack/subcontractor_company?scope=${scope}&${idKey}=${idValue}&order-by=created-at-desc`
  );

export const createHistorySubcontractorCompanyQuery = async ({ scope, data }) =>
  await api.post(`/datatrack/subcontractor_company?scope=${scope}`, data);

export const editHistorySubcontractorCompanyQuery = async ({
  id,
  data,
  scope,
}) =>
  await api.put(`/datatrack/subcontractor_company/${id}?scope=${scope}`, data);

export const deleteHistorySubcontractorCompanyQuery = async ({ scope, id }) =>
  await api.delete(`/datatrack/subcontractor_company/${id}?scope=${scope}`);
